module.exports = __webpack_public_path__ + "img/spins_460.07e55006.png";